import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';

@Injectable({
    providedIn: 'root'
})
export class CategoriaEquipamentoDBService extends DatabaseService {
    override classname: string = 'CategoriaEquipamentoDBService';
    override table = 'categoria_equipamento';

    protected override migration: number = 1;

    override indices = [
        { name: "by_id", field: "id", unique: false, multiEntry: false },
        { name: "by_descricao", field: "descricao", unique: false, multiEntry: false },
        { name: "by_sinc", field: "sinc", unique: false, multiEntry: false }
    ];
}

